<script>
import MonitoringChannel from "./Channel.vue";
import MonitoringWorker from "./Worker.vue";

export default {
  name: "MonitoringDisplay",
  components: {
    MonitoringChannel,
    MonitoringWorker,
  },
  props: {
    rmData: {
      type: Object,
    },
  },
}
</script>

<template>
  <div>
    <div v-if="rmData" class="d-md-flex gap-4">
      <div class="flex-grow-1">
        <h3 class="mb-3">{{ $t('remoteMonitoring.procedures.form.contacts') }}</h3>
        <div class="d-flex flex-column gap-1">
          <MonitoringChannel 
            v-for="(channel, i) in rmData.channels" 
            :key="channel.id" 
            :channel="channel"
            :index="i + 1" 
          />
          <div v-if="!rmData.channels.length" class="text-muted bg-gray-50 p-2 rounded">
            {{ $t('remoteMonitoring.display.no_channel')}}
          </div>
        </div>
      </div>
      <div class="flex-grow-1">
        <h3 class="mb-3">{{ $t('remoteMonitoring.procedures.form.devices') }}</h3>
        <div class="d-flex flex-column gap-1">
          <MonitoringWorker 
            v-for="(dati, i) in rmData.datis" 
            :key="dati.id" 
            :worker="dati"
            :index="i + 1" 
          />
          <div v-if="!rmData.datis.length" class="text-muted bg-gray-50 p-2 rounded">
            {{ $t('remoteMonitoring.display.no_user')}}
          </div>
        </div>
      </div>
    </div>
    <div v-if="!rmData" class="text-muted bg-gray-50 p-3 rounded text-md">
      {{ $t('remoteMonitoring.display.no_procedure')}}
    </div>
  </div>
</template>